import { ChangeDetectorRef, Component, computed, ContentChild, inject, Input, NgZone, Renderer2, TemplateRef, ViewEncapsulation } from '@angular/core';
import { EnpsComponent } from '@common/components/base/enps-component';
import { TileColumn } from '@common/data-models/misc/tile-column';
import { ItemDirective } from '@common/directives/item-directive';
import { GlobalTablesService } from '@common/services/global-tables-service';
import { LanguageSettings } from '@common/services/language-settings';
import { LayoutState } from '@common/services/layout-state';
import { Store } from '@ngrx/store';
import { TileDay } from '@src/suite/common/data-models/misc/tile-day';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { OpenFullscreenModalActions } from '@src/suite/common/store/fullscreen';
import { selectGroupByDateTimeField } from '@src/suite/common/store/navigation/selectors/viewstate.selectors';
import { selectTileViewColumns } from '@src/suite/common/store/playbook/playbook.selector';
import { RecordHttpActions } from '@src/suite/common/store/records/records.actions';
import { AppService } from '@suite/app.service';
import moment from 'moment';

@Component({
    selector: 'st-tile-view',
    templateUrl: './tile-view.html',
    styleUrls: ['./tile-view.scss'],
    encapsulation: ViewEncapsulation.None,
    host: {
        class: 'st-tile-view',
    },
})
export class TileViewComponent extends EnpsComponent {
    private store = inject(Store);

    tileViewColumns$ = this.store.select(selectTileViewColumns);

    isGroupedByDate = computed(() => {
        return this.store.selectSignal(selectGroupByDateTimeField)();
    });

    constructor(
        renderer: Renderer2,
        ngZone: NgZone,
        changeDetectorRef: ChangeDetectorRef,
        appService: AppService,
        public languageSettings: LanguageSettings,
        public globalTablesService: GlobalTablesService,
        private viewStateService: LayoutState
    ) {
        super();
    }

    @Input()
    public objectName: string = '';
    @Input()
    public childObjectName: string = '';

    private _dragDropEnabled: boolean = true;
    @Input()
    public get dragDropEnabled(): boolean {
        return this._dragDropEnabled;
    }
    public set dragDropEnabled(v: boolean) {
        this._dragDropEnabled = v;
    }

    @ContentChild(ItemDirective, { read: TemplateRef }) itemTemplate;

    public columns: Array<TileColumn> = [];

    public onEnterPredicate(column: any) {
        return () => {
            if (this.isGroupedByDate()) {
                const target: Date = new Date(column.value);
                const today: Date = new Date();

                if (moment(target).isBefore(moment(today, 'day').startOf('day'))) {
                    return false;
                }
            }

            return true;
        };
    }

    public async moveTopicInGroup(event: any, column: TileDay | TileColumn) {
        this.store.dispatch(RecordHttpActions.moveRecordToGroup({ sourceGuid: event.item.data.guid, targetGuid: null, sourceGroup: null, targetGroup: column.value }));
    }

    public createTopicInGroup(column: TileDay | TileColumn) {
        this.store.dispatch(
            OpenFullscreenModalActions.initCreateNewRecordFullscreen({
                groupData: column,
                recordType: ObjectTypes.TOPIC,
            })
        );
    }
}
